/** Tiny local hint bus so the websocket dispatcher stays decoupled from the coordinator. */

type Listener = () => void;

const listeners = new Set<Listener>();

export function emitNotificationInboxHint(): void {
  listeners.forEach((listener) => listener());
}

export function subscribeNotificationInboxHint(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
